// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import {
  ChevronRight,
  ExpandLess,
  ExpandMore,
} from '@/constants/hardfin-standard-icons';
import { Box, Button } from '@mui/material';
import { DateTime } from 'luxon';

interface Props {
  dayDate: DateTime;
  isOpen: boolean;
  onToggle: () => void;
}

function toLabel(isOpen: boolean, dayDate: DateTime) {
  const verb = isOpen ? 'Hide' : 'Show';
  return `${verb} project membership as of ${dayDate.toLocaleString(DateTime.DATE_MED)}`;
}

/** Opens and closes the serials under the daily change chart on the tab. */
export function MembersSerialsToggle(props: Props) {
  return (
    <Button
      variant="outlined"
      onClick={props.onToggle}
      startIcon={props.isOpen ? <ExpandLess /> : <ExpandMore />}
    >
      {toLabel(props.isOpen, props.dayDate)}
    </Button>
  );
}

/**
 * Opens and closes the serials beside the rules dialog. The dialog has no room
 * to expand them in place, so the caret turns to point at the panel rather than
 * down at a section that is about to appear below.
 */
export function MembersSerialsDialogToggle(props: Props) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button
        variant="outlined"
        onClick={props.onToggle}
        startIcon={props.isOpen ? <ChevronRight /> : <ExpandMore />}
      >
        {toLabel(props.isOpen, props.dayDate)}
      </Button>
    </Box>
  );
}
